import Swal from 'sweetalert2';
import { unity, regional, business, directory } from '../../modules/select';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_error_terms: 'Você deve aceitar os termos para continuar!',
    modal_error_required: 'Preencha os campos corretamente',
  },
  en: {
    modal_error_terms: 'You must accept the terms to proceed.',
    modal_error_required: 'Please fill out all the fields correctly',
  },
  es: {
    modal_error_terms: '¡Debes aceptar los términos para continuar!',
    modal_error_required: 'Rellena los campos correctamente',
  },
};

export const profilesTerms = () => {
  regional();
  unity();
  business();
  directory();
  validate();
};

const validate = () => {
  const $form = document.getElementById('form-terms');
  const $enrollment = document.getElementById('enrollment');
  const $phone = document.getElementById('mobile_phone');
  const $directory = document.getElementById('directory_id');
  const $regional = document.getElementById('regional_id');
  const $unity = document.getElementById('unity_id');
  const $business = document.getElementById('business_id');
  const $terms = document.querySelectorAll('.js-check');
  const $leadership = document.getElementById('leadership');

  $form.addEventListener('submit', e => {
    if (document.querySelectorAll('.js-check:checked').length !== $terms.length) {
      e.preventDefault();
      Swal.fire('', tr[lang].modal_error_terms, 'error');
    }

    if (
      !$enrollment.value ||
      !$phone.value ||
      !$directory.value ||
      !$regional.value ||
      !$unity.value ||
      !$business.value ||
      !$leadership.value ||
      $enrollment.value.length < 6
    ) {
      e.preventDefault();
      Swal.fire('', tr[lang].modal_error_required, 'error');
    }
  });
};
